import {
    isValidElement,
    type ReactNode,
    Children,
    Fragment
} from "react";
import type {
    AlertAnnouncementConstantType,
    AlertDescriptionConstantType
} from "./type";

const isAlertDescriptionPart = (node: ReactNode): boolean => {
    if(!isValidElement(node)) {
        return false;
    }

    const elementType: unknown = node.type;

    return typeof elementType === "function" && "alertPart" in elementType && elementType.alertPart === "description";
};

const hasAlertDescriptionPart = (children: ReactNode): boolean => {
    return Children.toArray(children).some((child) => {
        if(isValidElement<{
            children?: ReactNode;
        }>(child) && child.type === Fragment) {
            return hasAlertDescriptionPart(child.props.children);
        }

        return isAlertDescriptionPart(child);
    });
};

export const getHasAlertDescription = ({
    description,
    children
}: AlertDescriptionConstantType): boolean => {
    if(description !== undefined && description !== null && description !== false && description !== "") {
        return true;
    }

    return hasAlertDescriptionPart(children);
};

export const getAlertAnnouncement = ({
    description,
    title
}: AlertAnnouncementConstantType): string => {
    const descriptionText = typeof description === "string" || typeof description === "number" ? `${description}` : undefined;

    return [
        title,
        descriptionText
    ].filter((part) => !!part).join(". ");
};
